import { authApi } from "./authApi";
import { authStorage } from "./authStorage";
import { raisePendingPayments } from "./raisePendingPayments";
import type {
  AuthUser,
  LoginApiPayload,
  RefreshTokenResponse,
} from "./types";
import { tokenHandler } from "../../utils/tokenHandler";

export const authService = {
  login: async ({ userName, password }: LoginApiPayload): Promise<AuthUser> => {
    const data = await authApi.login({ userName, password });
    authStorage.setAuth(data);
    tokenHandler.touchActivity();
    // After the token is stored, so the request is authenticated. Not awaited.
    raisePendingPayments(data);
    return data;
  },

  refreshToken: async (): Promise<RefreshTokenResponse> => {
    const data = await authApi.refreshToken();
    if (typeof data?.token === "string" && data.token.trim().length > 0) {
      authStorage.updateToken(data.token);
      tokenHandler.touchActivity();
    }
    return data;
  },

  isAuthenticated: (): boolean => authStorage.hasToken(),

  getCurrentUser: (): AuthUser | null => authStorage.getAuth(),
};

export default authService;
